import * as React from "react"
import { useRecoilValue } from "recoil"
import { Button, Box } from "@chakra-ui/react"
import { ProductOptionButtonProps } from "./types"
import useOnClickWithTouchHandler from "../../../../hooks/useOnClickWithTouchHandler"
import { brandingSelector } from "../../../../recoil/atoms/room"

const _ProductOptionButton: React.FC<ProductOptionButtonProps> = ({
  isSmallMainScreen,
  isMobile,
  isDisabled,
  ...props
}): JSX.Element => {
  const roomStyles = useRecoilValue(brandingSelector)

  const callback = React.useCallback(
    e => {
      props.onChange(props.value)
      /* e.stopPropagation() */
    },
    [props]
  )

  const propsHandler = useOnClickWithTouchHandler(callback)

  return (
    <Box onClick={e => e.stopPropagation()}>
      <Button
        {...propsHandler}
        isDisabled={isDisabled}
        colorscheme="teal"
        variant="outline"
        width="unset"
        onClick={e => {
          props.onChange(props.value)
        }}
        size={isSmallMainScreen ? "xs" : "sm"}
        fontSize={isSmallMainScreen ? "xs" : "sm"}
        aria-checked={props.isChecked}
        _checked={{
          bg: roomStyles?.badgeSecondaryButtonSelectedColor ?? "black",
          color: roomStyles?.badgeSecondaryButtonSelectedTextColor ?? "white",
          borderColor: roomStyles?.badgeSecondaryButtonBorderColor
        }}
        padding="0.5rem"
        mr={"1"}
        marginTop="1"
        height={isMobile && "20px"}
        style={{ alignSelf: "flex-end", width: "unset" }}
        opacity={1}
        bg={roomStyles?.badgeSecondaryButtonBackgroundColor}
        _hover={{
          bg: roomStyles?.badgeSecondaryButtonMouseoverColor,
          color: roomStyles?.badgeSecondaryButtonTextMouseoverColor
        }}
        borderColor={roomStyles?.badgeSecondaryButtonBorderColor}
        color={roomStyles?.badgeSecondaryButtonTextColor}
        _focus={{}}
      >
        {props.children}
      </Button>
    </Box>
  )
}

export const ProductOptionButton = React.memo(_ProductOptionButton)
